import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import TextField from '../../../../components/TextField';

//Helpers
import { showMessage, showQuestion } from "../../../../helpers/message"

//Context
import { useAuth } from '../../../../context/auth';



function FormularioFiscalizacao({ execucaoFiscalizacao, setExecucaoFiscalizacao, formulario, errors, setShowButtons }) {
  const { setLoading } = useAuth();

  //Estado de controle do filtro das questões
  const [filtroQuestao, setFiltroQuestao] = useState("");

  //Tipos de valores para cada tipo de valor das questões
  const tipoValores = {
    "Lista": { type: "select" },
    "Texto": { type: "text" },
    "Número": { type: "number" },
    "Data": { type: "date" },
  };

  //Mime type de cada extensão aceita, usado para montar o link de visualização/download do anexo
  const mimePorExtensao = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    pdf: "application/pdf",
  };

  //Função que formata o valor do campo de acordo com o tipo
  const formatValue = (tipo, value) => {
    if (!!value) {
      if (tipo == "Lista") {
        return [{ value: value, label: value }];
      }
      return value;
    }
    return "";
  }

  //Função de onChange da resposta da questão
  const onChangeRespostas = (resp) => {
    setExecucaoFiscalizacao(_respostas => ({
      ..._respostas,
      formulario: execucaoFiscalizacao.formulario.map(value => {
        if (value.formularioQuestao_Id == resp.formularioQuestao_Id)
          return resp;
        return value;
      })
    }));
  }
  //onChange para os campos de tipo de fiscalizacao e tipo de serviço
  const onChangeSearchable = (value, e, formularioResposta) => {
    const _formularioResposta = {
      ...formularioResposta,
      [e.name]: value ? value.value.toString() : null,
    };

    onChangeRespostas(_formularioResposta)
  }

  // onChange dos campos de data, numero e texto
  const onChange = (e, formularioResposta) => {
    const { name, value } = e.target;
    const _formularioResposta = {
      ...formularioResposta,
      [name]: value,
    };
    onChangeRespostas(_formularioResposta)
  }
  //Função responsavel por pelo clique no botão de tirar foto
  const onClickSalvarFoto = (ref) => {
    ref.current.click();
  };

  //Função de onChange do arquivo
  const handleFileChange = (e, formularioResposta) => {
    const arquivo = e.target.files?.[0];
    if (!arquivo) return;

    const FR = new FileReader();
    FR.addEventListener("load", function (evt) {
      const extensao = evt.target.result.split("/")[1].split(";")[0];
      if (extensao != "png" && extensao != "jpg" && extensao != "jpeg" && extensao != "pdf") {
        showMessage("Aviso!", "Apenas arquivos das extensões png, jpg, jpeg, pdf são permitidos", "warning", null);
        return;
      }
      const _formularioResposta = {
        ...formularioResposta,
        anexos: [
          {
            arquivoBase64: evt.target.result.split("base64,")[1],
            dataHora: moment().format(),
            extensao: extensao,
            nomeArquivoOriginal: arquivo.name,
          }
        ],
      };
      onChangeRespostas(_formularioResposta);
    });
    FR.readAsDataURL(arquivo);
  };

  //Função que exclui o arquivo anexado, liberando a questão para ser respondida sem anexo
  const handleRemoverAnexo = (formularioResposta) => {
    showQuestion(
      "Tem certeza?",
      "Tem certeza de que deseja excluir o arquivo anexado?\n Esta ação é irreversível",
      "info",
      (confirmado) => {
        if (!confirmado) return;
        onChangeRespostas({ ...formularioResposta, anexos: [] });
      }
    );
  };

  useEffect(() => {
    setShowButtons(true);
  }, []);

  return (
    <div>
      {execucaoFiscalizacao.formulario.map((formularioResposta, key) => {
        const questaoFilter = formulario?.formularioQuestoes?.filter(value => formularioResposta?.formularioQuestao_Id == value.id && (filtroQuestao == "" || value.questao.toUpperCase().indexOf(filtroQuestao.toUpperCase()) != -1));
        const questao = questaoFilter.length > 0 ? questaoFilter[0] : null;
        //Fazendo o controle da cor do botão de foto caso ele seja obrigatorio
        let corBotaoFoto = "primary";

        if (formularioResposta.anexos && formularioResposta.anexos.length > 0)
          corBotaoFoto = "success";

        if (errors == true && questao.tirarFoto == "Obrigatorio" && formularioResposta.anexos.length == 0 && questao.obrigatorio)
          corBotaoFoto = "danger";

        if (!questao)
          return null;

        const ultimaQuestao = key === execucaoFiscalizacao.formulario.length - 1;

        return (
          <div key={key} style={{
            marginBottom: "24px",
            borderBottom: !ultimaQuestao ? "2px solid #726f6fff" : "none",
            paddingBottom: "20px"
          }}
          >
            <Row>
              <Col md="12">
                <p style={{ textAlign: "justify" }}>{questao.obrigatorio ? "*" : ""}{questao.questao}</p>
              </Col>
              <Col md="12" lg={questao.tirarFoto != "Sem foto" ? "8" : "12"}>
                <TextField
                  name={"valor"}
                  type={tipoValores[questao.tipoValor].type}
                  value={formatValue(questao.tipoValor, formularioResposta.valor)}
                  onChange={
                    tipoValores[questao.tipoValor].type == "select"
                      ? (value, e) => onChangeSearchable(value, e, formularioResposta)
                      : (e) => onChange(e, formularioResposta)
                  }
                  options={questao.formularioQuestaoOpcoes.map(value => ({ value: value.valor, label: value.valor }))}
                  invalid={errors == true && questao.obrigatorio && formularioResposta.valor == ""}
                  searchable={tipoValores[questao.tipoValor].type == "select"}
                  inputClassName={!!formularioResposta?.valor ? "input-border-thick" : ""}
                />

              </Col>
              {
                questao.tirarFoto != "Sem foto" &&
                <Col md="12" lg="4" className='d-flex flex-column align-items-center justify-content-center'>
                  <div className='d-flex w-100 align-items-center justify-content-center'>
                    <Button
                      className={`mb-2 ${formularioResposta.anexos && formularioResposta.anexos.length > 0 ? 'w-75' : 'w-100'}`}
                      color={corBotaoFoto}
                      onClick={() => onClickSalvarFoto(formularioResposta.capturarFotoRef)}
                    >
                      <FontAwesomeIcon icon={faCamera} /> Capturar foto
                    </Button>
                    {formularioResposta.anexos && formularioResposta.anexos.length > 0 &&
                      <Button
                        outline
                        color="danger"
                        className="w-25 mb-2 ms-2"
                        title="Excluir arquivo anexado"
                        onClick={() => handleRemoverAnexo(formularioResposta)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    }
                  </div>
                  <input
                    type="file"
                    ref={formularioResposta.capturarFotoRef}
                    onChange={(e) => handleFileChange(e, formularioResposta)}
                    style={{ display: "none" }}
                  />
                  {formularioResposta.anexos?.[0]?.nomeArquivoOriginal &&
                    <a
                      href={`data:${mimePorExtensao[formularioResposta.anexos[0].extensao] ?? "application/octet-stream"};base64,${formularioResposta.anexos[0].arquivoBase64}`}
                      download={formularioResposta.anexos[0].nomeArquivoOriginal}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='small text-center text-truncate w-100'
                    >
                      {formularioResposta.anexos[0].nomeArquivoOriginal}
                    </a>
                  }
                </Col>
              }
            </Row>
          </div>
        )
      })}
    </div>
  );
}

export default FormularioFiscalizacao;